/**
 * Hook que alimenta la campanita global y la futura vista "Mis tareas".
 * Wrappea la vista SQL core.v_my_due_tasks (ya filtra por auth.uid()).
 */
import { useQuery } from '@tanstack/react-query';

import * as dueApi from '../api/myDueTasks';
import { TASK_KEYS } from './keys';

export function useMyDueTasks() {
  return useQuery({
    queryKey: TASK_KEYS.myDue,
    queryFn: dueApi.listMyDueTasks,
    staleTime: 60_000,
  });
}
